import { H1, H2 } from "@/components/ui/headings"
import { MainLayout } from "@/org-admins/layouts/MainLayout"
import SignInForm from "@/org-admins/screens/onboarding/components/SignInForm"
import React from "react"

const SignInScreen = () => {
  return (
    <MainLayout showLogo={true}>
      <div className="mb-12">
        <H1>
          Welcome to the <br />
          Employer Admin Portal
        </H1>
        <H2>Sign in to get started</H2>
      </div>
      <SignInForm />
    </MainLayout>
  )
}

export default SignInScreen
